var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11 10",
    style: {
      enableBackground: "new 0 0 11 10"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2,10H1.8c-0.7,0-1.2-0.6-1.2-1.2V1.2C0.5,0.6,1.1,0,1.8,0H7c0.3,0,0.5,0.2,0.5,0.5S7.3,1,7,1H1.8C1.6,1,1.5,1.1,1.5,1.2 v7.5C1.5,8.9,1.6,9,1.8,9h7.5c0.1,0,0.2-0.1,0.2-0.2V4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4.8C10.5,9.4,9.9,10,9.2,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6.5c-0.1,0-0.2,0-0.3-0.1l-2.5-2C3,4.2,2.9,3.9,3.1,3.7c0.2-0.2,0.5-0.3,0.7-0.1l2.1,1.7l3.4-4.8C9.5,0.2,9.8,0.2,10,0.3 c0.2,0.2,0.3,0.5,0.1,0.7L6.4,6.3C6.3,6.4,6.2,6.5,6,6.5C6,6.5,6,6.5,6,6.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.4a07bcceea7678dc7ef12e81dcc11a37.svg";
export { ForwardRef as ReactComponent };